import { useAdRecruitStore } from "src/stores/AdRecruitStore"
import styled from "styled-components"
import { format } from 'date-fns';
import { CalendarEvent } from "./AdRecruitCalendar";
import { Icon_ArrowRight } from "../common/CommonIcons";
import { useModalStore } from "src/stores/ModalStore";
import { ModalContent_ModalRecruitCalendarDetail, ModalTitle_ModalRecruitCalendarDetail } from "./ModalRecruitCalendarDetail";

const Title_PageWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    position: relative;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
`

export const ModalTitle_RecruitCalendar_Mini = ()=>{
    const currnetdate = useAdRecruitStore((state)=>state.currnetdate)
    return(
        <Title_PageWrapper>
            {currnetdate ? format(new Date(currnetdate), 'M월 dd일') : '날짜 없음'}
        </Title_PageWrapper>
    )
}

const Content_PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;

    position: relative;
    margin-top: 24px;
`
const DataWrapper = styled('div')({
    display : 'flex',
    justifyContent:'center',
    alignItems:'center',

    border : '1px solid #EDEDED',
    borderRadius : '4px',
    padding : '12px 8px',
    gap : '8px',
    width:'100%'
})
interface TypeWrapperProps {
    type: string;
  }
const TypeWrapper = styled('div')<TypeWrapperProps>(({ type })=>({
    fontSize:'14px',
    margin: 'auto',
    border : '1px solid #0B4D3C',
    color : '#0B4D3C',
    padding : '3px',
    minWidth: '60px',
    display:'flex',
    justifyContent: 'center',
    alignItems:'center',
    borderRadius:'2px',
    backgroundColor:
    type === '추가과정'
      ? '#D1E9E7' // 추가접수 배경
      : type === '입영일'
      ? '#A4E6D5' // 입영일 배경
      : type === '임관일'
      ? '#A4E6D5' // 임관일 배경
      : type === '접수'
      ? '#CEDBD8' // 접수 배경
      : '#FFFFFF', // 기본 배경
}))
const TitleWrapper = styled('div')({
    display:'flex',
    justifyContent:'flex-start',
    alignItems:'center',
    flex:1,
    overflow:'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize:'18px',
    fontWeight:600
})

interface ModalContent_RecruitCalendar_Mini_Props{
    items:CalendarEvent[]
}

export const ModalContent_RecruitCalendar_Mini = ({items}:ModalContent_RecruitCalendar_Mini_Props)=>{
    const modalSetField = useModalStore((state)=>state.setField)
    
    const onClickShowDetail = async (event:CalendarEvent)=>{
        modalSetField('width','1120px')
        modalSetField('title',<ModalTitle_ModalRecruitCalendarDetail item={event}/>)
        modalSetField('content',<ModalContent_ModalRecruitCalendarDetail item={event}/>)
    }

    return(
        <Content_PageWrapper>
            {items?.map((event, idx) => (
                <DataWrapper onClick={()=>onClickShowDetail(event)}>
                    <TypeWrapper type={event.course_type}>{event.course_type}</TypeWrapper>
                    <TitleWrapper>{event.title}</TitleWrapper>
                    <Icon_ArrowRight/>
                </DataWrapper>
            ))}
        </Content_PageWrapper>
    )
}